import cn from 'classnames';
import React from 'react';
import styles from './ScrollbarContainer.module.css';

interface ScrollbarContainerProps {
	className?: string;
	style?: React.CSSProperties;
	children?: React.ReactNode;
}

export const ScrollbarContainer = React.forwardRef<HTMLDivElement, ScrollbarContainerProps>(function ScrollbarContainer(
	{className, style, children},
	ref,
) {
	return (
		<div className={cn(styles.root, className)} style={style} ref={ref}>
			{children}
		</div>
	);
});
